import { render, staticRenderFns } from "./WhereToBuy.vue?vue&type=template&id=6fc58e1c&scoped=true&"
import script from "./WhereToBuy.vue?vue&type=script&lang=js&"
export * from "./WhereToBuy.vue?vue&type=script&lang=js&"
import style0 from "./WhereToBuy.vue?vue&type=style&index=0&id=6fc58e1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc58e1c",
  null
  
)

export default component.exports